
export default class cookieScroll {
    constructor() {
        this.container = document.querySelector('footer');
        if (this.container === null) return;

        this.link = document.querySelector('.js-cookie-link');

        this.link.addEventListener('click', () => {
            window.scrollTo(0,0);
        });
    }
}